<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="pack-detail">
      <div class="pack-area">
        <ProductBanner
          v-if="currentPack"
          :packItem="currentPack"
          :showDetail="true"
        />
        <div v-if="currentPack" class="detail_area">
          <div class="name">{{currentPack.name}}</div>
          <div class="count01">
            <span class="c01">
              {{currentPack.point | comma}}<span v-if="currentPack.payment_method == '1'">Gem</span>
              <span v-if="currentPack.payment_method == '2'">coins</span>
              /play</span>
            <span class="c02">All {{ currentPack.total_pack_count | comma }}packs</span>
          </div>
          <div class="count02">
            <span class="c03">Residue {{ currentPack.pack_count | comma }}packs</span>
          </div>

          <div v-if="currentPack.format_end_date" class="end_date">
            <span>
              <span class="end_date_txt">End of sales</span>
              <span class="end_date_day">{{ currentPack.format_end_date }}</span>
            </span>
          </div>

          <div class="gray_area">
            <div class="point_base_area">
              <div class="count_base_area_block">
                <ErrorMessage
                  v-if="errorMessageCount"
                  class="error-message"
                  :message="errorMessageCount"
                />
                <div class="count_base_area">
                  <div class="area count_area">
                    <span>Number of purchase</span>
                    <SelectBox
                      class="select_box"
                      :options="buyList"
                      selectedOption="1"
                      @handleSelectChange="changeCount" />
                  </div>
                </div>
                <div class="limit_message" v-if="currentPack.can_limit === 1">
                  {{currentPack.limit_message}}
                </div>
              </div>
              <div class="area point_area">
                <span>Total amount</span>
                <span class="point">{{currentPack.point * count | comma}}
                  <span v-if="currentPack.payment_method == '1'">Gem</span>
                  <span v-if="currentPack.payment_method == '2'">C</span>
                </span>
              </div>
              <div class="buttons">
                <SquareButton
                  v-if="currentPack.can_limit === 0 && !isCountdown"
                  class="square-button"
                  text="BUY"
                  @handleSquareBtnClick="goToConfirmBuyProduct"
                />
                <div class="limit_message" v-if="errorMessageCount">{{ t(errorMessageCount) }}</div>
                <div class="countdown" v-if="isCountdown">
                  <span class="label_title">{{t('販売開始まで')}}</span>
                  <span class="num">{{countdownStr}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="currentPackCardList" class="card_list_area">
        <Title
          jpn="Card list"
          :small="true"
        />
        <div class="card_list">
          <img
            v-for="(row, key) in currentPackCardList.list"
            :key="key"
            :src="row.image_url"
            @click="handleDetailCard(row)"
          >
        </div>
        <BoxPager
          v-if="
            currentPackCardList &&
            currentPackCardList.page.pages.length > 1
          "
          class="box-pager"
          :totalPageCount="currentPackCardList.page.all_page"
          :currentPageCount="currentPackCardList.page.page"
          :dispBoxCount="currentPackCardList.page.pages.length"
          :pages="currentPackCardList.page.pages"
          @handlePagerClick="changeCurrentPageCount"
          @handleSquareBtnClick="changeCurrentPageCount"
        />
      </div>

      <div class="detail_block">
        <ProductDescription
          v-if="currentPack"
          title="Description of item"
          :description="setShopLink(currentPack.detail)"
        />
      </div>
    </div>
    <div v-if="showCardDetail" class="popup_card_area" @click.self="showCardDetail = false">
      <div class="popup_card">
        <div class="left">
          <img :src="popupCardData.image_url">
        </div>
        <div class="right">
          <div>{{popupCardData.name}}</div>
          <div>{{popupCardData.model_number}}</div>
          <div>{{popupCardData.rarity}}</div>
        </div>
      </div>
    </div>
    <CommonOverlay class="overlay" v-show="isOpenModal">
      <CommonModal v-if="currentPack.payment_method == '1'" class="modal pack-confirm">
        <div class="modal-title">
          <span>Insufficient points</span>
        </div>
        <div class="text">
          <span>Not enough points.</span>
          <span>do you want to buy?</span>
        </div>
        <div class="modal-button-area">
          <SquareButton
            class="square-button"
            text="NO"
            :isSub="true"
            @handleSquareBtnClick="closeModal"
          />
          <BlackGradationButton
            class="square-button"
            text="YES"
            @handleSquareBtnClick="goToBuyPoint"
          />
        </div>
      </CommonModal>
      <CommonModal v-if="currentPack.payment_method == '2'" class="modal pack-confirm">
        <div class="modal-title">
          <span>Insufficient coins</span>
        </div>
        <div class="text">
          <span>Not enough coins.</span>
        </div>
        <div class="modal-button-area">
          <SquareButton class="square-button" text="CLOSE" :isSub="true" @handleSquareBtnClick="closeModal" />
        </div>
      </CommonModal>
    </CommonOverlay>
    <CommonOverlay v-if="currentPack" class="overlay" v-show="isOpenConfirm">
      <CommonModal class="modal pack-confirm">
        <CloseButton
          class="close_button"
          @handleClick="closeModal"></CloseButton>
        <div class="modal-title">
          <span>{{currentPack.name}}</span>
        </div>
        <div class="block">
          <div class="subtitle">Number of purchase</div>
          <div class="main_data">{{ count | comma }} pack</div>
        </div>
        <div v-if="currentPack.payment_method == '1'"  class="block">
          <div class="subtitle">Gems to be spent</div>
          <div class="main_data mb">{{ currentPack.point * count | comma }}Gem</div>
          <div class="subtitle">Gems you held</div>
          <div class="use-point">
            <div class="point-area">{{ currentUser.point | comma }}</div>
            <div>→</div>
            <div class="point-area">{{ currentUser.point - (currentPack.point * count) | comma }}</div>
          </div>
        </div>
        <div v-if="currentPack.payment_method == '2'"  class="block">
          <div class="subtitle">Coins to be spent</div>
          <div class="main_data mb">{{ currentPack.point * count | comma }}C</div>
          <div class="subtitle">Coins you held</div>
          <div class="use-point">
            <div class="point-area">{{ currentUser.coin | commaFloat }}</div>
            <div>→</div>
            <div class="point-area">{{ currentUser.coin - (currentPack.point * count) | commaFloat }}</div>
          </div>
          <div class="attention">
            <span>This product is not redeemable for points (shipping only). Please forgive us in advance.</span>
          </div>
        </div>
        <div class="modal-button-area">
          <BlackGradationButton
            class="square-button"
            text="Confirm Purchase"
            @handleSquareBtnClick="buyPack"
          />
        </div>
      </CommonModal>
    </CommonOverlay>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  separateCharacterNumber,
  separateDecimalNumber,
} from '@/common/util/format';

import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import CloseButton from '@/components/atoms/CloseButton.vue';
import CommonOverlay from '@/components/atoms/CommonOverlay.vue';
import CommonModal from '@/components/atoms/CommonModal.vue';
import ProductBanner from '@/components/molecules/ProductBanner.vue';
import ProductDescription from '@/components/molecules/ProductDescription.vue';
import SquareButton from '@/components/atoms/SquareButton.vue';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
import SelectBox from '@/components/atoms/SelectBox.vue';
import Title from '@/components/molecules/Title.vue';
import BoxPager from '@/components/organisms/BoxPager.vue';
import t from '@/plugins/i18n';
import { shopLink } from '@/common/config/js/const';

export default {
  name: 'PackDetail',
  mixins: [t],

  components: {
    BaseTemplate,
    CloseButton,
    CommonOverlay,
    CommonModal,
    ProductBanner,
    ProductDescription,
    SquareButton,
    BlackGradationButton,
    SelectBox,
    Title,
    BoxPager,
  },

  data: () => ({
    isOpenModal: false,
    errorMessageCount: null,
    count: 1,
    showCardDetail: false,
    isOpenConfirm: false,
    popupCardData: {},
    isCountdown: false,
    countdownStr: '',
  }),

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      currentPack: 'pack/currentPack',
      currentPackCardList: 'pack/packCardList',
      packCheckResult: 'pack/packCheckResult',
      setCheckPackResult: 'pack/setCheckPackResult',
      buyPackResult: 'pack/buyPackResult',
    }),
    packPoint() {
      if (this.currentPack) {
        return separateCharacterNumber(this.currentPack.point);
      }
      return 0;
    },
    isAvailable() {
      return parseInt(this.currentUser.point, 10) >= parseInt(this.currentPack.point, 10);
    },
    packCount() {
      if (this.currentPack) {
        return separateCharacterNumber(this.currentPack.pack_count);
      }
      return 0;
    },
    buyList() {
      if (!this.packCount) {
        return [];
      }
      const count = parseInt(this.packCount.replace(',', ''), 10);
      let max = count;
      if (max > 3000) {
        max = 3000;
      }
      const maxCount = parseInt(this.currentPack.max_buy_count, 10);
      if (maxCount > 0 && max > maxCount) {
        max = maxCount;
      }
      const option = [];
      for (let i = 1; i <= max; i += 1) {
        option.push({ id: i, name: `${i}${this.t('パック')}` });
      }
      return option;
    },
  },

  created() {
    const { errorMessageCount } = this.$route.query;
    this.errorMessageCount = errorMessageCount ? errorMessageCount[0] : null;
    this.$store.dispatch('pack/setCurrentPack', { packId: this.$route.query.packId });
  },

  // beforeDestroy() {
  //   this.$store.dispatch('pack/clearCurrentPack');
  // },

  filters: {
    comma(value) {
      return separateCharacterNumber(value);
    },
    commaFloat(value) {
      return separateDecimalNumber(value, true);
    },
  },

  watch: {
    packCheckResult(newVal) {
      if (newVal) {
        if (newVal.state === 200 && newVal.result === '1') {
          // const query = {
          //   packId: this.$route.query.packId,
          //   buyCount: this.count,
          // };
          this.$store.dispatch('pack/clearPackCheckResult');
          // this.$router.push({ path: '/confirm-buy-product', query });
          this.isOpenConfirm = true;
        } else {
          const { count } = newVal.errors;
          this.errorMessageCount = count ? count[0] : null;
          this.isOpenModal = true;
        }
      }
    },
    currentPack(newVal) {
      if (newVal) {
        if (!newVal.id) {
          window.location.href = '/';
        }
        if (newVal.is_before) {
          this.isCountdown = true;
          this.setTimerID = setInterval(() => {
            this.setCountdownString();
          }, 1000);
          this.setCountdownString();
        }
        if (newVal.show_cardlist === '1') {
          this.$store.dispatch('pack/setPackCardList', { packId: newVal.id, pageNumber: 1 });
        } else {
          this.$store.dispatch('pack/clearPackCardList');
        }
      }
    },
  },

  methods: {
    setCountdownString() {
      const day1 = new Date(this.currentPack.start_date.replace(/-/g, '/'));
      const day2 = new Date();
      const diffDay = day1 - day2;
      if (diffDay < 0) {
        console.log('stop');
        this.isCountdown = false;
        console.log(this.isCountdown);
        clearInterval(this.setTimerID);
        return;
      }
      const h = `0${parseInt(diffDay / (1000 * 60 * 60), 10)}`.slice(-2);
      const m = `0${parseInt((diffDay % (1000 * 60 * 60)) / (1000 * 60), 10)}`.slice(-2);
      const s = `0${parseInt((diffDay % (1000 * 60)) / (1000), 10)}`.slice(-2);
      // const ms = `00${parseInt((diffDay % 1000), 10)}`.slice(-3);
      // this.countdownStr = `${h}.${m}.${s}.${ms}`;
      this.countdownStr = `${h}.${m}.${s}`;
    },
    // buyPack() {
    //   const query = {
    //     packId: this.$route.query.packId,
    //   };
    //   // ログインしていない場合、ログイン画面へ。routerのbeforeEachだとエラーが出る。（リダイレクトはされる）
    //   if (this.currentUser.is_login === '0') {
    //     this.$router.push({ path: '/login', query });
    //     return;
    //   }
    //   // 商品購入画面へ
    //   if (this.isAvailable) {
    //     this.$router.push({ path: '/buy-product', query });
    //     return;
    //   }
    //   this.isOpenModal = true;
    // },
    changeCount(val) {
      this.count = parseInt(val, 10);
    },
    closeModal() {
      this.isOpenModal = false;
      this.isOpenConfirm = false;
    },
    goToBuyPoint() {
      // ポイント購入画面へ
      const query = { packId: this.$route.query.packId };
      this.$router.push({ path: '/buy-point', query });
    },
    goToConfirmBuyProduct() {
      if (this.currentUser.is_login === '0') {
        this.$router.push({ path: '/login' });
        return;
      }
      const postParams = {
        count: String(this.count),
      };
      this.$store.dispatch('pack/setCheckPackResult', { postParams });
    },
    changeCurrentPageCount(page) {
      this.$store.dispatch('pack/setPackCardList', { packId: this.currentPack.id, pageNumber: page });
    },
    handleDetailCard(row) {
      this.popupCardData = row;
      this.showCardDetail = true;
    },
    buyPack() {
      (async () => {
        await this.$store.dispatch('pack/buyPack');
        const { buyPackResult } = this;
        const isSuceess = buyPackResult.state === 200 && buyPackResult.result === '1';
        if (isSuceess) {
          this.$store.dispatch('pack/clearBuyPackResult');
          this.$router.push('/gacha-animation');
        } else {
          const { count } = buyPackResult.errors;
          window.alert(count);
          this.isOpenConfirm = false;
        }
      })();
    },
    setShopLink(detail) {
      let result = detail;
      Object.keys(shopLink).forEach((key) => {
        const regex = new RegExp(key.replace(/[()]/g, '\\$&'), 'g');
        result = result.replace(regex, `<a href="${shopLink[key]}" target="_blank">${key}</a>`);
      });
      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
.pack-detail{
  width: 100%;
  max-width: 700px;
  min-height: 100vh;
  padding: 0 20px 26px 20px;
  margin: 0 auto 0 auto;
  color: $white;
  @include appendMap($backgroundStyleMap);

  .detail_area {
    padding: 10px 5px;
    .name {
      font-size: 36px;
      padding: 5px 0;
      border-bottom: solid 1px $white;
    }
    .count01 {
      display: flex;
      align-items: center;
      .c01 {
        font-size: 24px;
        margin-right: 20px;
      }
    }
    .count02 {
      margin-bottom: 5px;
    }
  }

  .gray_area {
    padding: 10px;
    .area {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .count_area {
      padding-bottom: 10px;
      border-bottom: solid 1px $white;
      span {
        font-size: 24px;
      }
      .select_box {
        max-width: 120px;
      }
    }
    .point_area {
      padding: 10px 0;
      .point {
        font-size: 24px;
      }
      span {
        font-size: 20px;
      }
    }
  }

  .detail_block {
    margin-top: 40px;
  }

  .card_list_area {
    .card_list {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      img {
        width: 100px;
        margin: 2px;
      }
    }
    .list_comment {
      margin: 20px 0;
      text-align: center;
    }
  }
}
.pack-confirm {
  max-width: 530px;
  padding: 20px;
  position: relative;
  .modal-title {
    font-size: 120%;
    text-align: center;
  }
  .block {
    background-color: #ebedf0;
    border-radius: 8px;
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin: 5px 20px;
    .subtitle {
      background-color: $mainColor;
      color: $white;
      min-width: 300px;
      text-align: center;
    }
    .main_data {
      color: $mainColor;
      font-size: 24px;
      font-weight: bold;
    }
    .mb {
      margin-bottom: 20px;
    }
    .use-point {
      display: flex;
      justify-content: center;
      align-items: center;
      color: $mainColor;
      .point-area {
        padding: 0 10px;
      }
    }
  }
  .close_button {
    position: absolute;
    right: 10px;
    top: 20px;
  }
}
.popup_card_area {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.4);
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .popup_card {
    padding: 20px 40px;
    background-color: #fff;
  }
}
.end_date {
  // text-align: center;
  // margin-top: 20px;
  // color: red;
  font-weight: bold;
  .end_date_txt {
    background-color: #e60012;
    color: $white;
    padding: 3px 10px;
  }
  .end_date_day {
    background-color: $white;
    color: #112877;
    padding: 3px 10px;
  }
}
@media screen and (max-width: $tabletWidth) {
  .pack-detail {
    margin-top: 100px;
    padding: 0 20px 26px 20px;
    .detail_block {
      margin-top: 30px;
      padding: 0;
    }

    .point_base_area {
      flex-direction: column;
      margin-top: 0;
      .point_area {
        width: 100%;
        text-align: center;
      }

      .count_base_area_block {
        width: 100% !important;
        padding: 0;

        .count_base_area {
          flex-direction: column;
          align-items: center;

          .count_area {
            margin: 20px 0;
          }
        }
      }
    }
    .pack-area {
      flex-direction: column;
      padding: 10px 10px 10px 10px;
      .detail_area {
        width: auto;
        .name {
          display: none;
        }
      }
    }
  }
  .card_list_area {
    margin-top: 20px;
    .card_list {
      display: flex;
      margin-bottom: 20px;
      img {
        width: auto!important;
        height: 90px;
        margin: 2px;
      }
    }
  }
  .buttons {
    margin: 0 auto;
    max-width: 500px;
    .square-button {
      width: 100%;
    }
  }
  .countdown {
    font-size: 18px;
    flex-direction: column;
    span.num {
      font-size: 24px;
    }
  }
  .detail_block {
    margin-top: 10px;
  }
  .overlay {
    .modal {
      width: 90%;
      .modal-button-area {
        flex-direction: column-reverse;
        .square-button {
          & + .square-button{
            margin-left: 0px;
            margin-bottom: 10px;
          }
        }
      }
    }
  }
  .pack-confirm {
    max-width: 100%;
    .modal-title {
      font-size: 120%;
      text-align: center;
    }
    .block {
      background-color: #ebedf0;
      border-radius: 8px;
      padding: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      margin: 5px 0;
      width: 100%;
      .subtitle {
        background-color: $mainColor;
        color: $white;
        min-width: 210px;
        text-align: center;
      }
      .main_data {
        color: $mainColor;
        font-size: 24px;
        font-weight: bold;
      }
      .mb {
        margin-bottom: 20px;
      }
      .use-point {
        display: flex;
        justify-content: center;
        align-items: center;
        color: $mainColor;
        .point-area {
          padding: 0 10px;
        }
      }
    }
    .close_button {
      position: absolute;
      right: 10px;
      top: 20px;
    }
  }
}
.attention {
  font-size: 12px;
  margin-top: 20px;
  color: red;
}
</style>
